<script lang="ts" setup>
provideHeadingContext()
</script>

<template>
  <div class="layout layout--checkout">
    <CheckoutTop class="layout__checkout-top" />

    <CheckoutHeader class="layout__checkout-header" />

    <main
      id="main"
      class="layout__main layout__checkout-main"
    >
      <slot />
    </main>

    <CheckoutFooter class="layout__checkout-footer" />

    <CartRestore />
  </div>
</template>

<style>
@import url("~layers/layouts/default.css");
@import url("~layers/layouts/checkout.css");
</style>
